import {
	Component,
	Input,
	OnInit,
	OnChanges,
	SimpleChanges,
} from '@angular/core';
import { MostSearchedProduct } from 'app/models/partner/insight-models';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
	selector: 'most-searched-products',
	templateUrl: './most-searched-products.component.html',
	styleUrls: ['./most-searched-products.component.scss'],
})
export class MostSearchedProductsComponent implements OnInit, OnChanges {
	@Input() locationId: number = 0;
	@Input() fromDate: Date = new Date();
	@Input() toDate: Date = new Date();

	public mostSearchedDataSource = new MatTableDataSource<MostSearchedProduct>();
	loading = false;
	isEmpty = false;
	public mostSearchedDisplayedColumns: string[] = [
		'ProductName',
		'SearchQuantity',
		'Conversions',
	];

	constructor(private liveAnnouncer: LiveAnnouncer) {}

	ngOnInit() {
		this.loadMostSearchedProducts();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['locationId'] || changes['fromDate'] || changes['toDate']) {
			this.loadMostSearchedProducts();
		}
	}

	onSearchedProductsSortChange(sortState: Sort) {
		if (sortState.direction) {
			this.liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
		} else {
			this.liveAnnouncer.announce('Sorting cleared');
		}
	}

	public loadMostSearchedProducts() {
		this.loading = true;
		this.isEmpty = false;
		this.mostSearchedDataSource.data = [];
		this.isEmpty = true;
		this.loading = false;
	}
}
